var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9213 5.51562H10.1885C10.0291 5.51562 9.87753 5.59219 9.78378 5.72344L7.32752 9.12969L6.21501 7.58594C6.12126 7.45625 5.97126 7.37813 5.81032 7.37813H5.07751C4.97595 7.37813 4.91657 7.49375 4.97595 7.57656L6.92283 10.2766C6.96882 10.3408 7.02945 10.3931 7.09969 10.4291C7.16994 10.4652 7.24777 10.4841 7.32674 10.4841C7.4057 10.4841 7.48354 10.4652 7.55378 10.4291C7.62402 10.3931 7.68465 10.3408 7.73064 10.2766L11.0213 5.71406C11.0822 5.63125 11.0228 5.51562 10.9213 5.51562Z",
    fill: "#00875A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8 13.8125C4.79063 13.8125 2.1875 11.2094 2.1875 8C2.1875 4.79063 4.79063 2.1875 8 2.1875C11.2094 2.1875 13.8125 4.79063 13.8125 8C13.8125 11.2094 11.2094 13.8125 8 13.8125Z",
    fill: "#00875A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.778a98621f908c9f388ef58f9ad10957.svg";
export { ForwardRef as ReactComponent };